/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useFormatMessage as t} from '../../i18n/translate';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Icon from "@material-ui/core/Icon";
import Collapse from '@material-ui/core/Collapse';

// core components
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks";
import RTLNavbarLinks from "../Navbars/RTLNavbarLinks";

import IconButton from '@material-ui/core/IconButton';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import styles, { mainColor } from "../../assets/jss/material-dashboard-react/components/sidebarStyle";
import bgImage from "../../assets/img/sidebar-4.jpg";
// import {ReactComponent as ERPLogo} from '../../assets/icons/erp.svg'
import { connect } from "react-redux";


const useStyles = makeStyles(styles);

const baseRouteStyle = {color:mainColor}
const NestedRoute = (props)=>{
  const {classes,routes,color, activeRoute} = props
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  let primaryModule = classNames({
    [" " + classes[color]]: activeRoute(routes.layout + 'none')
  });

  return(// nested Open Collapse Routes here
  <List className={classes.list} subheader={ <ListSubheader component="div" id="nested-list-subheader"></ListSubheader>}> 
      <ListItem button onClick={handleClick} >
        <ListItemAvatar>
          {/* <routes.icon style={baseRouteStyle}/> */}
          {routes.icon}
        </ListItemAvatar>
        <ListItemText primary={t(routes.parent)} style={baseRouteStyle} />
        <ListItemSecondaryAction>
          <IconButton edge="end" onClick={handleClick} aria-label="delete">
            {open ? <ExpandLess style={{color:mainColor}} /> : <ExpandMore style={{color:mainColor}} />}
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {routes.nestedRoutes.map((route,key)=>{
          let listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(route.layout + route.path)
          });
          let whiteFontClasses = classNames({
            [" " + classes.whiteFont]: activeRoute(route.layout + route.path)
          });
          let itemTexId = `${key}-sidemenue-${routes.parent?.replace(/\s/g, "")}-${route.name.replace(/\s/g, "")}`
          return(              
            <NavLink
              to={route.layout + route.path}
              className={classes.item}
              activeClassName="active"
            >
              <ListItem button style={{paddingLeft:'2.25rem'}}  className={ listItemClasses}>
                <ListItemAvatar>
                  {/* <route.icon style={{ResizeObserverSize:'1rem'}}/> */}
                  {/* this behvior is strange */}
                  {route.icon}
                </ListItemAvatar>
                <ListItemText id={itemTexId} primary={t(route.name)} className={classNames(classes.itemText, whiteFontClasses)} disableTypography={true}/>
              </ListItem>
            </NavLink>
          )
        })}
      </Collapse>
  </List>
  )
}

const SimpleRoute = (props)=>{
  const {classes, route, color, activeRoute} = props
  let listItemClasses = classNames({
    [" " + classes[color]]: activeRoute(route.layout + route.path)
  });
  let whiteFontClasses = classNames({
    [" " + classes.whiteFont]: activeRoute(route.layout + route.path)
  });
  let itemTexId = `$main-sidemenue-${route.name.replace(/\s/g, "")}`

  return(
    <List className={classes.list} subheader={ <ListSubheader component="div" id="nested-list-subheader"></ListSubheader>}>
    <NavLink
      to={route.layout + route.path}
      className={classes.item}
      activeClassName="active"
      key={route.navBarName}
    >
      <ListItem button className={ listItemClasses}>
        <ListItemAvatar>
          <route.icon />
        </ListItemAvatar>
      <ListItemText id={itemTexId} primary={<p>{t(route.name)}</p>} className={classNames(classes.itemText, whiteFontClasses)}
        disableTypography={true}/>
      </ListItem>
    </NavLink>
  </List>

  )
}

function Sidebar(props) {
  const classes = useStyles();
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, logo, image, logoText, routes } = props;
  // console.log({image})
  let links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        // var activePro = " ";
        // var listItemClasses;
        // if (prop.path === "/upgrade-to-pro") {
        //   activePro = classes.activePro + " ";
        //   listItemClasses = classNames({
        //     [" " + classes[color]]: true
        //   });
        // } else {
        //   listItemClasses = classNames({
        //     [" " + classes[color]]: activeRoute(prop.layout + prop.path)
        //   });
        // }
        // // here color the active route
        // const whiteFontClasses = classNames({
        //   [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path)
        // });
        if (prop.parent) return <NestedRoute classes={classes} routes={prop} color={color} activeRoute={activeRoute} />
        return <SimpleRoute classes={classes} route={prop} color={color} activeRoute={activeRoute} />
       
      })}
    </List>
  );
  const Brand =
    <div style={{background:'white',width:'48%',padding:'0.25rem',margin:'0.5rem 0.25rem',borderRadius:'1rem',zIndex:3}} classNames={classes.logo} >
      {/* <ERPLogo style={{width:"7.25rem"}} /> */}
      <img src="/erp.png" width="100%"/>

    </div>
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {Brand} 
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: `url(${bgImage})` }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {Brand} 
          <div className={classes.sidebarWrapper}>
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: `url(${bgImage})` }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
// Sidebar.propTypes = {
//   rtlActive: PropTypes.bool,
//   handleDrawerToggle: PropTypes.func,
//   bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
//   logo: PropTypes.string,
//   image: PropTypes.string,
//   logoText: PropTypes.string||PropTypes.object,
//   routes: PropTypes.arrayOf(PropTypes.object),
//   open: PropTypes.bool
// };
